import getMessageFromError from 'ha/utils/getMessageFromError';
import { makeRequestAction } from './actions';
import { ANOTHER_DATES } from '../constants/Actions';

export default (conversationId, { startDate, endDate }) => (
  dispatch,
  _,
  { apiV2 },
) => {
  dispatch(makeRequestAction.start({ type: ANOTHER_DATES }));

  return apiV2
    .changeConversationDate(conversationId, { startDate, endDate })
    .then(({ data }) =>
      apiV2
        .getConversationMessages(conversationId)
        .then(messages => [data, messages]),
    )
    .then(([data, { data: { messages } }]) => {
      dispatch(makeRequestAction.done({ ...data, messages }));
    })
    .catch(({ cause: { response: { errors } } }) => {
      dispatch(makeRequestAction.error(getMessageFromError(errors[0])));
    });
};
